export default {
  document: {
    '@light': {
      color: 'dark',
      background: 'cream'
    },
    '@dark': {
      color: 'cream92',
      background: 'dark'
    }
  },
  dark: {
    color: 'cream92',
    background: 'dark'
  },
  blue: {
    color: 'white',
    background: 'accent'
  },
  none: {
    color: 'none',
    background: 'none'
  },
  transparent: {
    color: 'currentColor',
    background: 'transparent'
  }
}
